import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c55928c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field--no-tin" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "is-exist-tin-number" }
const _hoisted_4 = {
  key: 0,
  class: "row row--absence-of-tin-number"
}
const _hoisted_5 = { class: "row--absence-of-tin-number__question" }
const _hoisted_6 = {
  key: 0,
  class: "row--next-tax-residence__other-reason"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_Radio = _resolveComponent("Radio")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CheckBox, {
        modelValue: _ctx.formData.noTinNumber,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.formData.noTinNumber = $event)),
        name: _ctx.name,
        "cy-data": "no-tin",
        class: "valid"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.isExistTinNumber`)), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "name"])
    ]),
    (_ctx.formData.noTinNumber)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.explainAbsenceOfTin`)), 1),
          _createVNode(_component_Radio, {
            label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.tinNumberInformationOne`),
            name: _ctx.name + 'Reason',
            value: _ctx.NoTinReason.NOT_ISSUED,
            "cy-data": "no-tin-not-issued",
            class: "valid",
            onUpdateValue: _ctx.setNoTinReason
          }, null, 8, ["label", "name", "value", "onUpdateValue"]),
          _createVNode(_component_Radio, {
            label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.tinNumberInformationTwo`),
            name: _ctx.name + 'Reason',
            value: _ctx.NoTinReason.UNABLE_TO_GET,
            "handles-error": false,
            "cy-data": "no-tin-unable-to-get",
            class: "valid",
            onUpdateValue: _ctx.setNoTinReason
          }, null, 8, ["label", "name", "value", "onUpdateValue"]),
          _createVNode(_component_Radio, {
            label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.tinNumberInformationThree`),
            name: _ctx.name + 'Reason',
            value: _ctx.NoTinReason.OTHER,
            "handles-error": false,
            class: _normalizeClass([[
                    _ctx.formData.noTinNumber && _ctx.formData.noTinNumberReason !== 3
                        ? 'margin-bottom'
                        : '',
                ], "valid"]),
            "cy-data": "no-tin-other",
            onUpdateValue: _ctx.setNoTinReason
          }, null, 8, ["label", "name", "value", "class", "onUpdateValue"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (
                    _ctx.formData.noTinNumberReason === _ctx.NoTinReason.OTHER &&
                    _ctx.formData.noTinNumber
                )
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_Field, {
                modelValue: _ctx.formData.noTinNumberOtherReason,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.noTinNumberOtherReason = $event)),
                type: "text",
                name: _ctx.name + 'OtherReason',
                placeholder: 
                        _ctx.$t(`${_ctx.TRANSLATION_KEY}.otherReasonPlaceholder`)
                    ,
                "cy-data": "no-tin-reason"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.reason`)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "name", "placeholder"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}